"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRUE = exports.FALSE = void 0;
const TRUE = "true";
exports.TRUE = TRUE;
const FALSE = "false";
exports.FALSE = FALSE;
